"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: function _default() {
        return {
          userName: '',
          loginCode: '',
          token: ''
        };
      }
    }
  },
  data: function data() {
    return {
      isVisible: false,
      formLabelWidth: '120px',
      formValue: {
        userPk: '',
        userName: '',
        loginCode: '',
        userMobile: '',
        remark: ''
      }
    };
  },
  watch: {
    isShow: function isShow(val) {
      this.isVisible = val;
    },
    form: function form(val) {
      this.formValue = (0, _objectSpread2.default)({}, this.form);
    }
  },
  mounted: function mounted() {},
  methods: {
    clickCloseBtn: function clickCloseBtn(done) {
      this.$emit('dialogHidden');
    },
    clickCancel: function clickCancel() {
      this.$emit('dialogHidden');
    }
  }
};